import styled from 'styled-components';

export const Container = styled.div`
  #card-wrapper.left {
    top: 25px !important;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/admin/cards/style.js